import axios from '../axios.js';

var api = {
  //最新公开课 免费训练营  预约
  subscribe(params) {
    return axios.post('index/curriculum/insert_reservation', params)
  },
  //最新公开课 免费训练营  详情
  subDetails(params) {
    return axios.post('index/curriculum/class_info', params)
  }
}

export default api



// WEBPACK FOOTER //
// ./src/api/openClass.js